<div (click)="swapSlider()"
     *ngIf="wallet else loading"
     class="wallet-head master gbo_shadow">
    <label style="word-break: break-word">
        <i *ngIf="wallet.active" class="bi bi-bookmark-check color174882"></i>
        <i *ngIf="!wallet.active" class="bi bi-bookmark-x-fill text-danger"></i>
        {{ wallet.title }}
    </label>
    <span class="master_total adaptive">
        {{ wallet.total | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
    </span>
</div>

<div *ngIf="wallet && (structWalletsInfo[wallet.guid] && showWallet) else loadingSmall"
     class="wallet-content master gbo_shadow">
    <div class="row p-2">
        <div class="col-9 p-4">
            <div class="totalPanel">
                <div class="financeTotalSum">
                    {{ wallet.total | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                </div>
            </div>
        </div>

        <div class="col-3">
            <div class="btn-group-vertical w-100">
                <button (click)="onShowReplenishmentDialog()"
                        class="btn btn-light"
                        data-action="showMasterReplenishment">
                    <i class="bi bi-box-arrow-in-down"></i>
                    {{ 'FINANCE.BUTTONS.TOP_UP' | translate }}
                </button>
                <button (click)="onShowBarterDialog()"
                        class="btn btn-light"
                        data-action="showMasterBarter">
                    <i class="bi bi-arrow-left-right"></i> {{ 'FINANCE.BUTTONS.TRANSFER' | translate }}
                </button>
                <button (click)="modalService.openTemplateModal(transactionView)"
                        class="btn btn-light"
                        data-action="showMasterTransaction">
                    <i class="bi bi-credit-card"></i> {{ 'FINANCE.BUTTONS.PAY' | translate }}
                </button>
                <button (click)="modalService.openTemplateModal(moreView)"
                        class="btn btn-light infoButton"
                        data-action="showMasterInfo">
                    <i class="bi bi-info-circle"></i> {{ 'FINANCE.BUTTONS.MORE' | translate }}
                </button>
                <button (click)="loadPaymentsHistory(wallet, historyWalletView)"
                        class="btn btn-light"
                        data-action="showMasterHistory">
                    <i class="bi bi-clock-history"></i> {{ 'FINANCE.BUTTONS.HISTORY' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- пополнение баланса -->
<ng-container *ngIf="isShowReplenishmentModal">
    <app-replenishment (emitFinish)="onCloseModal($event); isShowReplenishmentModal = false"
                       [wallet]="wallet">
    </app-replenishment>
</ng-container>

<!-- вывод денег -->
<ng-container *ngIf="isShowPayoutModal">
    <app-payout (emitFinish)="onCloseModal($event); isShowPayoutModal = false"
                [wallet]="wallet">
    </app-payout>
</ng-container>

<!-- перевод денег -->
<ng-container *ngIf="isShowBarterModal">
    <app-barter (emitFinish)="onCloseModal($event); isShowBarterModal = false"
                [isMaster]="true"
                [outWallet]="wallet"
                [purse]="financeProfile">
    </app-barter>
</ng-container>

<ng-template #historyWalletView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-payment-modal
                [detail]="false"
                [payments]="wallet.payments"
                [walletProjectGuid]="wallet.project_guid"
        ></app-payment-modal>
    </div>
</ng-template>

<ng-template #transactionView let-modal>
    <app-button-modal-close [modal]="modal" modalSize="lg"></app-button-modal-close>
    <div [innerHTML]="'MODALS.TEXT.PAY_ERROR' | translate"
         class="modal-body"
    ></div>
</ng-template>

<ng-template #moreView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div class="wallets" style="width: auto">
            <div class="wallet">
                <div class="wallet-content">
                    <div class="row" style="margin-top: 20px;">
                        <div class="col-6">
                            <ul class="list-payments">
                                <li class="promised">
                                    {{ 'MODALS.TEXT.PAYMENTS.EXPECTED_BLOCKED' | translate }}:
                                    + {{ structWalletsInfo[wallet.guid].expectedBlocked | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                                </li>
                                <li class="def">
                                    {{ 'MODALS.TEXT.PAYMENTS.EXPECTED' | translate }}:
                                    + {{ structWalletsInfo[wallet.guid].expected | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                                </li>
                            </ul>
                        </div>
                        <div class="col-6">
                            <ul class="list-payments">
                                <li class="expected">
                                    {{ 'MODALS.TEXT.PAYMENTS.PROMISED_BLOCKED' | translate }}:
                                    - {{ structWalletsInfo[wallet.guid].promisedBlocked | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                                </li>
                                <li class="def">
                                    {{ 'MODALS.TEXT.PAYMENTS.PROMISED' | translate }}:
                                    - {{ structWalletsInfo[wallet.guid].promised | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="margin-left: 20px">
            <small>
                GUID: {{ wallet.guid }}<br>
                {{ 'MODALS.TEXT.LAST_TRANSACTION' | translate }}: {{ helper.formatDate(wallet.last_operation_at) }}<br>
                {{ 'MODALS.TEXT.CREATED' | translate }}: {{ helper.formatDate(wallet.created_at) }}
            </small>
        </div>
    </div>
</ng-template>

<ng-template #loading>
    <app-component-loading *ngIf="isLoadingData"></app-component-loading>
    <div *ngIf="isLoadingDataError" class="alert alert-danger">{{ 'CONNECTION_ERROR' | translate }}</div>
</ng-template>

<ng-template #loadingSmall>
    <app-component-loading *ngIf="isLoadingData" size="smail"></app-component-loading>
    <div *ngIf="isLoadingDataError" class="alert alert-danger">{{ 'CONNECTION_ERROR' | translate }}</div>
</ng-template>
